import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatPercentage } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  frac_correct_engine_size_configuration: 0.9,
  report_category: "AT_SEA_REPORT",
  frac_correct_single_small_engine: 0.85,
  single_small_engine_threshold: 0.8,
  load_weighted_avg: 0.8,
  weighted_load_threshold: 0.75,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  unit = "%",
  metadata = defaultMetadata,
  missingDataMsg,
  bvrColour,
  isExample,
}) {
  let atSea = metadata["report_category"] === "AT_SEA_REPORT";
  let actual = 0;
  let threshold = 0;
  let axisLabel = "";
  let barName = "";
  if (atSea) {
    actual = Number(metadata["load_weighted_avg"]) * 100;
    threshold = Number(metadata["weighted_load_threshold"]) * 100;
    axisLabel = "Engine load percentage (%)";
    barName = "Average load (>8kts)";
  } else {
    actual = Number(metadata["frac_correct_single_small_engine"]) * 100;
    threshold = Number(metadata["single_small_engine_threshold"]) * 100;
    axisLabel = "Percentage of time (%)";
    barName = "Small DG use in port";
  }

  if (isNaN(actual)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const data = [
    {
      name: barName,
      mobileName: "Label",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["500"] : bvrColour.codes["200"],
      overThresholdColour: bvrColour.codes["500"],
    },
  ];

  const domainMin = 0;
  const domainMax = 110;
  const domain = [domainMin, domainMax];

  const ticks = [];
  for (let i = domainMin + 1; i < domainMax / 10; i++) {
    ticks.push(i * 10);
  }

  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Signol threshold (${
        formatPercentage("0-100", threshold, 0, { boundaryValues: [0, actual] })
          .formattedValue
      })`}
      mobileDomain={domain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={!(threshold < actual)}
      unitOfMeasure={unit}
      axisLabel={axisLabel}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) =>
        `${formatPercentage("0-100", value, 0, { boundaryValues: [0, threshold] }).formattedValue}`
      }
      ticks={ticks}
      isExample={isExample}
    />
  );
}
